"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.accountProviders = void 0;
__exportStar(require("./BaseAtoms"), exports);
__exportStar(require("./CancelOrderLog"), exports);
__exportStar(require("./ClaimSeatLog"), exports);
__exportStar(require("./CreateMarketLog"), exports);
__exportStar(require("./DepositLog"), exports);
__exportStar(require("./FillLog"), exports);
__exportStar(require("./GlobalAddTraderLog"), exports);
__exportStar(require("./GlobalAtoms"), exports);
__exportStar(require("./GlobalClaimSeatLog"), exports);
__exportStar(require("./GlobalCleanupLog"), exports);
__exportStar(require("./GlobalCreateLog"), exports);
__exportStar(require("./GlobalDepositLog"), exports);
__exportStar(require("./GlobalEvictLog"), exports);
__exportStar(require("./GlobalWithdrawLog"), exports);
__exportStar(require("./PlaceOrderLog"), exports);
__exportStar(require("./QuoteAtoms"), exports);
__exportStar(require("./QuoteAtomsPerBaseAtom"), exports);
__exportStar(require("./WithdrawLog"), exports);
const CreateMarketLog_1 = require("./CreateMarketLog");
const ClaimSeatLog_1 = require("./ClaimSeatLog");
const DepositLog_1 = require("./DepositLog");
const WithdrawLog_1 = require("./WithdrawLog");
const FillLog_1 = require("./FillLog");
const PlaceOrderLog_1 = require("./PlaceOrderLog");
const CancelOrderLog_1 = require("./CancelOrderLog");
const GlobalCreateLog_1 = require("./GlobalCreateLog");
const GlobalAddTraderLog_1 = require("./GlobalAddTraderLog");
const GlobalClaimSeatLog_1 = require("./GlobalClaimSeatLog");
const GlobalDepositLog_1 = require("./GlobalDepositLog");
const GlobalWithdrawLog_1 = require("./GlobalWithdrawLog");
const GlobalEvictLog_1 = require("./GlobalEvictLog");
const GlobalCleanupLog_1 = require("./GlobalCleanupLog");
const QuoteAtoms_1 = require("./QuoteAtoms");
const BaseAtoms_1 = require("./BaseAtoms");
const GlobalAtoms_1 = require("./GlobalAtoms");
const QuoteAtomsPerBaseAtom_1 = require("./QuoteAtomsPerBaseAtom");
exports.accountProviders = {
    CreateMarketLog: CreateMarketLog_1.CreateMarketLog,
    ClaimSeatLog: ClaimSeatLog_1.ClaimSeatLog,
    DepositLog: DepositLog_1.DepositLog,
    WithdrawLog: WithdrawLog_1.WithdrawLog,
    FillLog: FillLog_1.FillLog,
    PlaceOrderLog: PlaceOrderLog_1.PlaceOrderLog,
    CancelOrderLog: CancelOrderLog_1.CancelOrderLog,
    GlobalCreateLog: GlobalCreateLog_1.GlobalCreateLog,
    GlobalAddTraderLog: GlobalAddTraderLog_1.GlobalAddTraderLog,
    GlobalClaimSeatLog: GlobalClaimSeatLog_1.GlobalClaimSeatLog,
    GlobalDepositLog: GlobalDepositLog_1.GlobalDepositLog,
    GlobalWithdrawLog: GlobalWithdrawLog_1.GlobalWithdrawLog,
    GlobalEvictLog: GlobalEvictLog_1.GlobalEvictLog,
    GlobalCleanupLog: GlobalCleanupLog_1.GlobalCleanupLog,
    QuoteAtoms: QuoteAtoms_1.QuoteAtoms,
    BaseAtoms: BaseAtoms_1.BaseAtoms,
    GlobalAtoms: GlobalAtoms_1.GlobalAtoms,
    QuoteAtomsPerBaseAtom: QuoteAtomsPerBaseAtom_1.QuoteAtomsPerBaseAtom,
};
